module.exports = __webpack_public_path__ + "img/volume.690c72df.png";